import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  Divider,
  Stack
} from '@mui/material';

const HOAFooter = () => {
  return (
    <div style={{backgroundColor: '#e5e7eb', color: '#374151',
      padding: "3rem", paddingBottom: "1.5rem", margin: "0 -2rem"}} >
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent="space-between">

          {/* Office Bearers Column */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                fontFamily: 'serif',
                fontSize: '1.125rem',
                mb: 3
              }}
            >
              OFFICE BEARERS
            </Typography>
            <Stack spacing={2}>
              <Box>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, mb: 0.5 }}
                >
                  President:
                </Typography>
                <Link
                  href="mailto:president.agcoa@gmail.com"
                  sx={{
                    color: '#374151',
                    textDecoration: 'none',
                    borderBottom: '2px solid transparent',
                    pb: 0.5,
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    transition: 'border-color 0.3s ease',
                    '&:hover': {
                      borderBottomColor: '#374151',
                      textDecoration: 'none'
                    }
                  }}
                >
                  president.agcoa@gmail.com
                </Link>
              </Box>
              <Box>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, mb: 0.5 }}
                >
                  Treasurer:
                </Typography>
                <Link
                  href="mailto:treasurer.agcoa@gmail.com"
                  sx={{
                    color: '#374151',
                    textDecoration: 'none',
                    borderBottom: '2px solid transparent',
                    pb: 0.5,
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    transition: 'border-color 0.3s ease',
                    '&:hover': {
                      borderBottomColor: '#374151',
                      textDecoration: 'none'
                    }
                  }}
                >
                  treasurer.agcoa@gmail.com
                </Link>
              </Box>
              <Box>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, mb: 0.5 }}
                >
                  Secretary:
                </Typography>
                <Link
                  href="mailto:secretaryagcoa@gmail.com"
                  sx={{
                    color: '#374151',
                    textDecoration: 'none',
                    borderBottom: '2px solid transparent',
                    pb: 0.5,
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    transition: 'border-color 0.3s ease',
                    '&:hover': {
                      borderBottomColor: '#374151',
                      textDecoration: 'none'
                    }
                  }}
                >
                  secretaryagcoa@gmail.com
                </Link>
              </Box>
            </Stack>
          </Grid>

          {/* Contact Information Column */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                fontFamily: 'serif',
                fontSize: '1.125rem',
                mb: 3
              }}
            >
              CONTACT DETAILS
            </Typography>
            <Stack spacing={1.5}>
              <Typography
                variant="body2"
                sx={{ fontWeight: 600 }}
              >
                Phone Numbers:
              </Typography>
              <Link
                href="tel:+918939111092"
                sx={{
                  color: '#374151',
                  textDecoration: 'none',
                  borderBottom: '2px solid transparent',
                  pb: 0.5,
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  transition: 'border-color 0.3s ease',
                  display: 'block',
                  '&:hover': {
                    borderBottomColor: '#374151',
                    textDecoration: 'none'
                  }
                }}
              >
                +91 8939111092
              </Link>
              <Link
                href="tel:+918939575959"
                sx={{
                  color: '#374151',
                  textDecoration: 'none',
                  borderBottom: '2px solid transparent',
                  pb: 0.5,
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  transition: 'border-color 0.3s ease',
                  display: 'block',
                  '&:hover': {
                    borderBottomColor: '#374151',
                    textDecoration: 'none'
                  }
                }}
              >
                +91 8939575959
              </Link>
            </Stack>
          </Grid>

          {/* Association Details Column */}
          <Grid item xs={12} md={4}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                fontFamily: 'serif',
                fontSize: '1.125rem',
                mb: 3,
                textAlign: { xs: 'center', lg: 'left' }
              }}
            >
              ASSOCIATION DETAILS
            </Typography>
            <Box sx={{ textAlign: { xs: 'center', lg: 'left' } }}>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 900,
                  letterSpacing: '0.1em',
                  mb: 2,
                  lineHeight: 1.2
                }}
              >
                <Box
                  component="span"
                  sx={{
                    fontSize: '1.4rem',
                    color: '#22543d'
                  }}
                >
                  Aspen Greens
                </Box>{' '}
                <Box
                  component="span"
                  sx={{
                    fontSize: '1rem',
                    color: '#1f2937'
                  }}
                >
                  <br />Chennai Owners Association
                </Box>
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: '0.875rem',
                  fontWeight: 500
                }}
              >
                <Box component="span" sx={{ fontWeight: 600 }}>
                  Registration No:
                </Box>{' '}
                490/2021
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {/* Divider */}
        <Divider
          sx={{
            my: 4,
            borderColor: '#d1d5db', // gray-300
            borderWidth: '1px'
          }}
        />

        {/* Copyright */}
        <Box sx={{ textAlign: 'center' }}>
          <Typography
            variant="body2"
            sx={{
              fontSize: '0.875rem',
              color: '#6b7280'
            }}
          >
            © 2025-27 Aspen Greens Chennai Owners Association. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </div>
  );
};

export default HOAFooter;
